/* Website + Twitter + TikTok + YouTube are not required – commented */
import React from "react";
import BenevvTextField from "components/forms/BenevvTextField/BenevvTextField";
import BenevvDropDown from "components/forms/BenevvDropDown/BenevvDropDown";
import CreateOrganizationcss from "../../CreateOrgMain/CreateOrganization.module.css";
import { statesData, countryData } from "../../DropDownData/DropDownData";
import { Autocomplete, TextField } from "@mui/material";
import { StyleContainer } from "./BasicOrgInfo.styles";

interface Props {
  setOrgName: (v: string) => void;
  setStreetAddress: (v: string) => void;
  setOrgCity: (v: number | string) => void;
  /* setWebsite?: (v: string) => void; */ /* ❌ BACKEND NOT USED – commented for now */
  setOrgInsta: (v: string) => void;
  /* setOrgYoutube?: (v: string) => void; */ /* ❌ BACKEND NOT USED – commented for now */
  /* setOrgTwitter?: (v: string) => void; */ /* ❌ BACKEND NOT USED – commented for now */
  /* setOrgTikTok?: (v: string) => void; */ /* ❌ BACKEND NOT USED – commented for now */
  setOrgFace: (v: string) => void;
  setOrgState: (v: string) => void;
  setCountry: (v: string) => void;
  setOrgImage: (v: string) => void;
  setDescription: (v: string) => void;
  cities: { id: number; name: string }[];
}

const StackedField = ({ label, children, fullWidth = false, halfWidth = false, alignRight = false, wide = false, gridFullWidth = false }: { label: React.ReactNode; children: React.ReactNode; fullWidth?: boolean; halfWidth?: boolean; alignRight?: boolean; wide?: boolean; gridFullWidth?: boolean }) => (
  <div
    style={{
      width: gridFullWidth ? '100%' : undefined,
      maxWidth: gridFullWidth ? '100%' : fullWidth ? '100%' : wide ? '100%' : halfWidth ? 'calc(50% - 1rem)' : '46%',
      flex: gridFullWidth ? undefined : fullWidth ? '1 1 100%' : halfWidth ? '1 1 calc(50% - 1rem)' : '1 1 46%',
      minWidth: fullWidth ? '100%' : '16.25rem',
      marginBottom: '1.25rem',
      justifySelf: alignRight ? 'end' : undefined,
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <label style={{ color: '#fe2f67', fontSize: '1.05rem', marginBottom: 6, whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' }}>{label}</label>
    {children}
  </div>
);

export function BasicOrgInfo({
  setOrgName,
  setStreetAddress,
  setOrgCity,
  /* setWebsite, */ /* ❌ */ setOrgInsta,
  /* setOrgYoutube, */ /* ❌ */
  /* setOrgTwitter, */ /* ❌ */
  /* setOrgTikTok, */ /* ❌ */
  setOrgFace,
  setOrgState,
  setCountry,
  setOrgImage,
  setDescription,
  cities,
}: Props) {
  return (
    <>
      <h2 className={CreateOrganizationcss.sectionHeader}>
        2. Basic Organization Information
      </h2>

      {/* Row 1: Name + Logo URL */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 2fr',
          gap: '2rem',
          width: '100%',
        }}
      >
        <StackedField label="Organization Name *" halfWidth>
          <BenevvTextField
            styleInput={{ width: "100%", height: "3rem", minHeight: "3rem", maxHeight: "3rem", padding: "0.5rem 1.25rem", boxSizing: "border-box" }}
            htmlFor="orgName"
            placeholder="Enter organization name"
            required
            setTextField={setOrgName}
            maxLength={100}
          />
        </StackedField>
        <StackedField label="Organization Logo URL *" alignRight gridFullWidth>
          <BenevvTextField
            styleInput={{ width: "100%", height: "3rem", minHeight: "3rem", maxHeight: "3rem", padding: "0.5rem 1.25rem", boxSizing: "border-box" }}
            htmlFor="orgImage"
            placeholder="https://example.com/logo.png"
            required
            setTextField={setOrgImage}
            maxLength={250}
          />
        </StackedField>
      </div>

      {/* Row 1: Country/Region | State | City (same row, auto widths, space between them) */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1.5rem', marginBottom: '1.25rem' }}>
        <div style={{ flex: '1 1 0', minWidth: 180, maxWidth: '32%' }}>
          <StackedField label="Country/Region">
            <BenevvDropDown
              label=""
              placeholder="Select country"
              values={countryData}
              setTextField={setCountry}
              styleDropDown={{ width: "100%", height: "3rem", minHeight: "3rem", maxHeight: "3rem", lineHeight: "3rem" }}
            />
          </StackedField>
        </div>
        <div style={{ flex: '1 1 0', minWidth: 180, maxWidth: '32%' }}>
          <StackedField label="State">
            <BenevvDropDown
              label=""
              placeholder="Select state"
              values={statesData}
              setTextField={setOrgState}
              styleDropDown={{ width: "100%", height: "3rem", minHeight: "3rem", maxHeight: "3rem", lineHeight: "3rem" }}
            />
          </StackedField>
        </div>
        <div style={{ flex: '1 1 0', minWidth: 180, maxWidth: '32%' }}>
          <StackedField label="City">
            <BenevvDropDown
              label=""
              placeholder="Select city"
              values={cities.map(city => city.name)}
              setTextField={name => {
                const city = cities.find(c => c.name === name);
                setOrgCity(city ? city.id : "");
              }}
              styleDropDown={{ width: "100%", height: "3rem", minHeight: "3rem", maxHeight: "3rem", lineHeight: "3rem" }}
            />
          </StackedField>
        </div>
      </div>

      {/* Row 2: Street Address (100%) */}
      <StackedField label="Street Address *" fullWidth>
        <BenevvTextField
          styleInput={{ width: "100%", height: "3rem", minHeight: "3rem", maxHeight: "3rem", padding: "0.5rem 1.25rem", boxSizing: "border-box" }}
          htmlFor="streetAddress"
          placeholder="Enter street address"
          required
          setTextField={setStreetAddress}
          maxLength={100}
        />
      </StackedField>

      {/* Row 4: Instagram + Facebook */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '2rem',
          width: '100%',
        }}
      >
        <StackedField label="Organization Instagram Handle *">
          <BenevvTextField
            styleInput={{ width: "100%", height: "3rem", minHeight: "3rem", maxHeight: "3rem", padding: "0.5rem 1.25rem", boxSizing: "border-box" }}
            htmlFor="instagram"
            placeholder="e.g. @myorg"
            required={false}
            setTextField={setOrgInsta}
            maxLength={100}
          />
        </StackedField>
        <StackedField label="Organization Facebook Profile *" alignRight>
          <BenevvTextField
            styleInput={{ width: "100%", height: "3rem", minHeight: "3rem", maxHeight: "3rem", padding: "0.5rem 1.25rem", boxSizing: "border-box" }}
            htmlFor="facebook"
            placeholder="Enter Facebook URL"
            required={false}
            setTextField={setOrgFace}
            maxLength={250}
          />
        </StackedField>
      </div>

      {/* Row 5: Description (100%) */}
      <div style={{ width: "100%" }}>
        <StackedField label="Organization Description *" fullWidth>
          <BenevvTextField
            styleInput={{ width: "100%", height: "6rem", minHeight: "6rem", padding: "0.5rem 1.25rem", boxSizing: "border-box" }}
            htmlFor="orgDescription"
            placeholder="Brief summary (max 500 chars)"
            required
            maxLength={500}
            setTextField={setDescription}
            multiline
          />
        </StackedField>
      </div>

      {/* ---- The following fields are NOT required by backend ---- */}
      {/*
      <BenevvTextField ... setWebsite(...) />          // ❌ BACKEND NOT USED
      <BenevvTextField ... setOrgYoutube(...) />      // ❌ BACKEND NOT USED
      <BenevvTextField ... setOrgTwitter(...) />      // ❌ BACKEND NOT USED
      <BenevvTextField ... setOrgTikTok(...)  />      // ❌ BACKEND NOT USED
      */}
    </>
  );
}
